// src/pages/PrivacyPage.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import EmailLink from '../components/EmailLink';
import '../styles/PrivacyPage.css';

export default function PrivacyPage() {
  return (
    <main className="privacy-page">
      <Helmet>
        <title>Privacy Policy – Typing Test</title>
        <meta 
          name="description" 
          content="Privacy policy for Typing Test. Learn how we collect, use, and protect your information when you visit our website." 
        />
      </Helmet>
      <div className="container">
        <h1>Privacy Policy</h1>
        <h2>Introduction</h2>
        <p>Welcome to Typing Test. Your privacy is important to us. This Privacy Policy document explains the types of information collected and recorded by Typing Test and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us at <EmailLink />.</p>
        <p>This privacy policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect on Typing Test. This policy does not apply to any information collected offline or via channels other than this website.</p>
        <h2>Consent</h2>
        <p>By using our website, you hereby consent to our Privacy Policy and agree to our <Link to="/terms/">Terms and Conditions</Link>.</p>
        <h2>Information We Collect</h2>
        <p>We do not collect personal data such as your name or email address, as it is not possible to create an account on our website. However, we do collect certain information automatically through our use of Google Analytics, which may include:</p>
        <ul>
          <li><strong>Derivative Data:</strong> Information our servers automatically collect when you access the Site, such as your IP address, browser type, operating system, access times, and the pages you viewed before and after accessing the Site.</li>
        </ul>
        <h2>How We Use Your Information</h2>
        <p>We use the information we collect in various ways, including to:</p>
        <ul>
          <li>Provide, operate, and maintain our website</li>
          <li>Improve, personalize, and expand our website</li>
        </ul>
        <h2>Google Analytics</h2>
        <p>We use Google Analytics to collect information about your use of the Site. Google Analytics collects information such as how often users visit the Site, what pages they visit, and what site referred them to our Site. We use the data from Google Analytics only to improve our Site. Google Analytics collects only the IP address assigned to you on the date you visit the Site, rather than your name or other identifying information.</p>
        <p>We do not combine the information collected through the use of Google Analytics with personally identifiable information. Although Google Analytics plants a permanent cookie on your web browser to identify you as a unique user the next time you visit the Site, the cookie cannot be used by anyone but Google. Google's ability to use and share information collected by Google Analytics about your visits to the Site is restricted by the Google Analytics Terms of Use and the Google Privacy Policy.</p>
      </div>
    </main>
  );
}
